export default __webpack_public_path__ + "static/welldesigned-c6108f78186a01d8ab250c7c71138628.jpg";